/**
 * valida y remueve espacios
 * @param prop: string
 * @returns string
 */
export const toReadableText = (prop: string): string => {
	if (typeof prop !== "string") return "";

	return prop.trim().toLowerCase() ?? "";
};

// limpia los datos y elimina los empty
export const toReadableTextFromList = (matchers: string[]): string[] => {
	return matchers
		.map((matcher) => toReadableText(matcher))
		.filter((matcher) => Boolean(matcher));
};

export const isEmptyText = (value: string): boolean => {
	return toReadableText(value).length === 0;
};

export const isNotEmptyText = (value: string): boolean => {
	return !isEmptyText(value);
};

export const isArray = (value: any): boolean => {
	return Array.isArray(value);
};

export const checkAndGetValueArray = <T>(value: any): T[] => {
	return isArray(value) ? value : [];
};

export const isString = (value: any): boolean => {
	return typeof value === "string";
};

export const isObject = (value: any) => {
	return value !== null && typeof value === "object" && !Array.isArray(value);
};


export const deepCopy = (obj: any) => {
	if (obj === null || typeof obj !== "object") return obj;
	if (Array.isArray(obj)) return obj.map(deepCopy);
	const copia = {};
	for (const key in obj) {
		copia[key] = deepCopy(obj[key]);
	}
	return copia;
}

export const isNonEmptyObject = (value: any): boolean => {
	return (
		value !== null &&                  // no es null
		typeof value === "object" &&       // es objeto
		!Array.isArray(value) &&           // no es array
		Object.keys(value).length > 0      // tiene propiedades
	);
}

export function normalizeEmptyToNull<T>(
	value: T | null | undefined
): T | null {
	if (value == null) return null;

	if (typeof value === 'string') {
		return value.trim() ? value : null;
	}

	if (isPlainObject(value)) {
		return Object.keys(value).length ? value : null;
	}

	return value;
}

function isPlainObject(value: unknown): value is Record<string, unknown> {
	return typeof value === 'object' && value !== null && !Array.isArray(value);
}